import React,{Component} from 'react';

import { Row, Col } from 'reactstrap';

class ExpandedStartDateTitle extends Component {
  render(){
    return (
      <Row>
        <Col xs='4'>
          <strong>Start date</strong>
        </Col>
        <Col xs='4'>
          <strong>End date</strong>
        </Col>
      </Row>
    )
  }
}

export default ExpandedStartDateTitle;



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignCreation/components/ExpandedStartDateTitle.js